import { Grid } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';

const ItemGrid: FCWithChildren = ({ children, ...rest }) => (
  <Grid
    alignItems="center"
    gridGap="space-40"
    templateColumns="1fr 70px 110px 60px 40px"
    {...rest}
  >
    {children}
  </Grid>
);

export default ItemGrid;
